import DataTable from "components/DataTable";
import { ReactNode } from "react";
interface Column {
  key: string;
  label: string;
  actions?: (row: Row) => React.ReactNode;
  excludeExport?: boolean;
}
interface Row {
  id: number;
  [key: string]: ReactNode;
}
interface FormersProps {
  data: Row[];
  columns: Column[];
  itemsPerPage?: number;
  loading?: boolean;
  onAdd?: () => void;
  title?: string;
  currentPage?: number;
  totalItems?: number;
  onPageChange?: (page: number) => void;
  onItemsPerPageChange?: (itemsPerPage: number) => void;
  serverSide?: boolean;
  onSearchChange?: (searchTerm: string) => void;
}

const Distributors = ({
  data,
  columns,
  loading,
  onAdd,
  title,
  currentPage = 1,
  totalItems = 0,
  itemsPerPage = 10,
  onPageChange,
  onItemsPerPageChange,
  serverSide = false,
  onSearchChange,
}: FormersProps) => {
  return (
    <div>
      <DataTable
        data={data}
        columns={columns}
        title={title}
        onAddBtnClick={onAdd}
        loading={loading}
        serverSide={true}
        currentPage={currentPage}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        onPageChange={onPageChange}
        onItemsPerPageChange={onItemsPerPageChange}
       onSearchChange={onSearchChange}
      ></DataTable>
    </div>
  );
};
export default Distributors;
